{
	"update-info": {
		"forced": {
			"title": "We kindly ask you to update the app",
			"message": "The current version is no longer supported. Please go to your app store and update to the latest version."
		},
		"optional": {
			"title": "New version available!",
			"message": "Update to the latest version when you're ready to enjoy the latest features."
		},
		"whats-new": "What's new",
		"version": "Version",
		"maybe-later": "Maybe later",
		"update-now": "Update now"
	}
}
